<div class="container-fluid ">
	<!-- Header del perfil -->
	<div class="row justify-content-center mb-4">
		<div class="col-12">
			<div class="text-center mb-4">
				<h1 class="display-5 fw-bold mb-2 text-dark">Mi Perfil Profesional</h1>
				<p class="lead text-muted">Gestiona tu información personal y experiencia laboral</p>
			</div>
		</div>
	</div>

	<!-- Loading principal -->
	<div class="row justify-content-center" *ngIf="loadingStates.main">
		<div class="col-md-6">
			<div class="card shadow-lg border-0">
				<div class="card-body text-center py-5">
					<div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
						<span class="visually-hidden">Cargando datos...</span>
					</div>
					<h5 class="text-muted">Cargando información del candidato...</h5>
				</div>
			</div>
		</div>
	</div>

	<!-- Contenido principal -->
	<div class="row" *ngIf="!loadingStates.main">

		<!-- COLUMNA IZQUIERDA - INFORMACIÓN PERSONAL -->
		<div class="col-12 col-lg-4 mb-4">
			<div class="card shadow-lg border-0 sticky-top" style="border-radius: 20px; top: 20px;">
				<div class="card-body text-center p-4">

					<!-- Imagen de perfil -->
					<div class="position-relative mb-4">
						<div class="profile-image-container mx-auto mb-3">
							<img [src]="'/assets/img/user-placeholder.svg'" alt="Foto de perfil"
								class="rounded-circle shadow-lg"
								style="width: 150px; height: 150px; object-fit: cover; border: 4px solid #fff;">
							<button class="btn btn-primary btn-sm rounded-circle position-absolute bottom-0 end-0 p-2"
								style="transform: translate(10px, -10px);">
								<i class="bi bi-camera"></i>
							</button>
						</div>
					</div>

					<!-- Información básica -->
					<div class="text-center mb-4">
						<h4 class="fw-bold text-dark mb-1">
							{{ candidatoData.name || 'Nombre' }} {{ candidatoData.lastName || 'Apellido' }}
						</h4>
						<p class="text-muted mb-3">{{ candidatoData.professionalGoal || 'Objetivo profesional no
							especificado' }}</p>

						<!-- Salario deseado destacado -->
						<div class="bg-info bg-gradient text-white rounded-pill py-2 px-3 mb-3">
							<i class="bi bi-currency-dollar me-2"></i>
							<strong>{{ candidatoData.desiredMonthlySalary || 'No especificado' }}</strong>
							<small class="d-block opacity-75">Salario mensual deseado</small>
						</div>
					</div>

					<!-- Información de contacto -->
					<div class="border-top pt-3">
						<div class="d-flex align-items-center mb-2" *ngIf="candidatoData.email">
							<i class="bi bi-envelope text-primary me-3"></i>
							<span class="text-dark">{{ candidatoData.email }}</span>
						</div>
						<div class="d-flex align-items-center mb-2" *ngIf="candidatoData.phone">
							<i class="bi bi-telephone text-primary me-3"></i>
							<span class="text-dark">{{ candidatoData.phone }}</span>
						</div>
						<div class="d-flex align-items-center mb-2" *ngIf="candidatoData.addressState">
							<i class="bi bi-geo-alt text-primary me-3"></i>
							<span class="text-dark">{{ candidatoData.addressState }}, {{
								candidatoData.addressMunicipality }}</span>
						</div>
						<div class="d-flex align-items-start" *ngIf="candidatoData.addressStreet">
							<i class="bi bi-house text-primary me-3 mt-1"></i>
							<span class="text-dark">{{ candidatoData.addressStreet }}</span>
						</div>
					</div>

					<!-- Botón de editar información personal 
					<button *ngIf="!editingModules.personalInfo"
						class="btn btn-outline-primary btn-lg rounded-pill w-100 mt-3"
						(click)="editarInformacionPersonal()">
						<i class="bi bi-pencil me-2"></i>
						Editar Perfil
					</button>-->
				</div>
			</div>
		</div>

		<!-- COLUMNA DERECHA - RESTO DEL CONTENIDO -->
		<div class="col-12 col-lg-8">

			<!-- OBJETIVO PROFESIONAL Y SALARIO -->
			<div class="card shadow-lg border-0 mb-4" style="border-radius: 15px;">
				<div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3"
					style="border-radius: 15px 15px 0 0;">
					<div class="d-flex align-items-center">
						<div class="bg-info bg-gradient rounded-circle p-3 me-3">
							<i class="bi bi-bullseye text-white fs-4"></i>
						</div>
						<div>
							<h5 class="mb-0 fw-bold text-dark">Objetivo Profesional</h5>
							<small class="text-muted">Metas y aspiraciones laborales</small>
						</div>
					</div>
					<button *ngIf="!editingModules.personalInfo"
						class="btn btn-outline-success btn-lg rounded-pill px-4" (click)="editarInformacionPersonal()">
						<i class="bi bi-pencil me-2"></i>
						Editar
					</button>
				</div>
				<div class="card-body bg-white">
					<!-- Modo vista -->
					<div *ngIf="!editingModules.personalInfo">
						<div class="row g-4">
							<div class="col-12">
								<div class="bg-light rounded-3 p-4">
									<h6 class="text-success fw-bold mb-3">
										<i class="bi bi-target me-2"></i>Objetivo Profesional
									</h6>
									<p class="mb-0 text-dark"
										*ngIf="candidatoData?.professionalGoal; else noObjetivo">
										{{ candidatoData.professionalGoal }}
									</p>
									<ng-template #noObjetivo>
										<p class="text-muted mb-0">No se ha definido un objetivo profesional</p>
									</ng-template>
								</div>
							</div>
							<div class="col-12 col-md-6">
								<div class="bg-light rounded-3 p-4">
									<h6 class="text-success fw-bold mb-3">
										<i class="bi bi-currency-dollar me-2"></i>Salario Esperado
									</h6>
									<p class="mb-0 text-dark" *ngIf="candidatoData?.desiredMonthlySalary; else noSalario">
										${{ candidatoData.desiredMonthlySalary | number:'1.0-0' }} MXN
									</p>
									<ng-template #noSalario>
										<p class="text-muted mb-0">No especificado</p>
									</ng-template>
								</div>
							</div>
							<div class="col-12 col-md-6">
								<div class="bg-light rounded-3 p-4">
									<h6 class="text-success fw-bold mb-3">
										<i class="bi bi-briefcase me-2"></i>Modalidad Preferida
									</h6>
									<p class="mb-0 text-dark" *ngIf="candidatoData?.preferredModality; else noModalidad">
										{{ candidatoData.preferredModality }}
									</p>
									<ng-template #noModalidad>
										<p class="text-muted mb-0">No especificado</p>
									</ng-template>
								</div>
							</div>
						</div>
					</div>
					<!-- Modo edición -->
					<div *ngIf="editingModules.personalInfo">
						<div class="row g-4">
							<div class="col-12">
								<div class="form-floating">
									<textarea class="form-control border-0 bg-light" id="professionalGoal"
										[(ngModel)]="candidatoData.professionalGoal"
										placeholder="Describe tu objetivo profesional..."
										style="min-height: 120px; resize: none;"></textarea>
									<label for="professionalGoal" class="text-muted">
										<i class="bi bi-target me-2"></i>Tu objetivo profesional
									</label>
								</div>
							</div>
							<div class="col-12 col-md-6">
								<div class="form-floating">
									<input type="number" class="form-control border-0 bg-light" id="desiredMonthlySalary"
										[(ngModel)]="candidatoData.desiredMonthlySalary" placeholder="Salario esperado">
									<label for="desiredMonthlySalary" class="text-muted">
										<i class="bi bi-currency-dollar me-2"></i>Salario esperado (MXN)
									</label>
								</div>
							</div>
							<div class="col-12 col-md-6">
								<div class="form-floating">
									<select class="form-select border-0 bg-light" id="preferredModality"
										[(ngModel)]="candidatoData.preferredModality">
										<option value="">Seleccionar modalidad</option>
										<option value="Presencial">Presencial</option>
										<option value="Remoto">Remoto</option>
										<option value="Híbrido">Híbrido</option>
									</select>
									<label for="preferredModality" class="text-muted">
										<i class="bi bi-briefcase me-2"></i>Modalidad de trabajo
									</label>
								</div>
							</div>
						</div>
						<div class="d-flex gap-2">
							<button type="button" class="btn btn-success"
								(click)="guardarInformacionPersonal()" [disabled]="loadingStates.personalInfo">
								<span *ngIf="loadingStates.personalInfo"
									class="spinner-border spinner-border-sm me-2"></span>
								<i *ngIf="!loadingStates.personalInfo" class="bi bi-check-circle me-2"></i>
								Guardar
							</button>
							<button type="button" class="btn btn-secondary"
								(click)="cancelarEdicionInformacionPersonal()" [disabled]="loadingStates.personalInfo">
								<i class="bi bi-x-lg me-2"></i>
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>
			<!-- 💼 EXPERIENCIA LABORAL -->
			<div class="card shadow-lg border-0 mb-4" style="border-radius: 15px;">
				<div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3"
					style="border-radius: 15px 15px 0 0;">
					<div class="d-flex align-items-center">
						<div class="bg-info bg-gradient rounded-circle p-3 me-3">
							<i class="bi bi-briefcase-fill text-white fs-4"></i>
						</div>
						<div>
							<h5 class="mb-0 fw-bold text-dark">Experiencia Laboral</h5>
							<small class="text-muted">Historial profesional y logros</small>
						</div>
					</div>
					<button *ngIf="!editingModules.workExperience"
						class="btn btn-outline-success btn-lg rounded-pill px-4" (click)="editarExperienciaLaboral()">
						<i class="bi bi-pencil me-2"></i>
						Editar
					</button>
				</div>
				<div class="card-body px-4 pb-4">
					<!-- Modo vista -->
					<div *ngIf="!editingModules.workExperience">
						<div *ngIf="candidatoData.hasWorkExperience?.length === 0" class="text-center py-5">
							<div class="bg-light rounded-circle p-4 mx-auto mb-3" style="width: 80px; height: 80px;">
								<i class="bi bi-briefcase text-muted fs-2"></i>
							</div>
							<h6 class="text-muted">No hay experiencia laboral registrada</h6>
							<p class="text-muted small">Agrega tu primera experiencia profesional</p>
						</div>
						<div class="row g-4" *ngIf="candidatoData.hasWorkExperience?.length > 0">
							<div class="col-12" *ngFor="let exp of candidatoData.hasWorkExperience; let i = index">
								<div class="bg-light rounded-3 p-4 position-relative">
									<div class="position-absolute top-0 start-0 bg-success rounded-pill" style="width: 4px; height: 100%;"></div>
									<div class="ms-3">
										<div class="d-flex justify-content-between align-items-start mb-2">
											<div>
												<h6 class="text-success fw-bold mb-1">{{ exp.position || 'Puesto no
													especificado' }}</h6>
												<p class="text-dark fw-semibold mb-1">{{ exp.company || 'Empresa no
													especificada' }}</p>
												<p class="text-muted small mb-0">
													<i class="bi bi-calendar3 me-1"></i>
													{{ exp.from || 'Fecha inicio' }} - {{ exp.to || 'Actualidad' }}
												</p>
											</div>
											<span class="badge bg-success bg-gradient rounded-pill">
												<i class="bi bi-check-circle me-1"></i>Experiencia
											</span>
										</div>
										<div class="mt-3" *ngIf="exp.descriptionOfActivities">
											<p class="text-dark mb-0">{{ exp.descriptionOfActivities }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Modo edición -->
					<div *ngIf="editingModules.workExperience">
						<!-- Lista de experiencias existentes -->
						<div *ngFor="let exp of candidatoData.hasWorkExperience; let i = index"
							class="border p-3 mb-3 rounded">
							<div class="d-flex justify-content-between align-items-start">
								<div>
									<h6>{{ exp.position || 'Puesto no especificado' }}</h6>
									<p class="text-muted mb-1">{{ exp.company || 'Empresa no especificada' }}</p>
									<p class="text-muted mb-0">
										<small>{{ exp.from || 'Fecha inicio' }} - {{ exp.to || 'Actualidad' }}</small>
									</p>
								</div>
								<div class="btn-group">
									<button class="btn btn-outline-primary btn-sm" (click)="editarExperiencia(i)">
										<i class="bi bi-pencil"></i>
									</button>
									<button class="btn btn-outline-danger btn-sm" (click)="eliminarExperiencia(i)">
										<i class="bi bi-trash"></i>
									</button>
								</div>
							</div>
						</div>

						<!-- Formulario para agregar/editar experiencia -->
						<div class="border p-3 mb-3 rounded bg-light" *ngIf="editIndexes.workExperience !== null">
							<h6>{{ editIndexes.workExperience >= 0 ? 'Editar' : 'Agregar' }} Experiencia</h6>
							<div class="row">
								<div class="col-md-6">
									<div class="mb-3">
										<label class="form-label">Puesto</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.workExperience.position">
									</div>
									<div class="mb-3">
										<label class="form-label">Empresa</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.workExperience.company">
									</div>
								</div>
								<div class="col-md-6">
									<div class="mb-3">
										<label class="form-label">Fecha de inicio</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.workExperience.from" placeholder="Ej: Enero 2020">
									</div>
									<div class="mb-3">
										<label class="form-label">Fecha de fin</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.workExperience.to"
											placeholder="Ej: Diciembre 2022 o Actualidad">
									</div>
								</div>
								<div class="col-12">
									<div class="mb-3">
										<label class="form-label">Descripción de actividades</label>
										<textarea class="form-control" rows="3"
											[(ngModel)]="editingData.workExperience.descriptionOfActivities"></textarea>
									</div>
								</div>
							</div>
							<div class="d-flex gap-2">
								<button class="btn btn-success btn-sm" (click)="guardarExperiencia()">
									<i class="bi bi-check-lg me-1"></i>
									Guardar
								</button>
								<button class="btn btn-secondary btn-sm" (click)="cancelarEdicionItem()">
									<i class="bi bi-x-lg me-1"></i>
									Cancelar
								</button>
							</div>
						</div>

						<!-- Botón para agregar nueva experiencia -->
						<button class="btn btn-outline-primary mb-3" (click)="agregarExperiencia()">
							<i class="bi bi-plus-lg me-1"></i>
							Agregar Experiencia
						</button>

						<!-- Botones de acción del módulo -->
						<div class="d-flex gap-2">
							<button class="btn btn-success" (click)="guardarModuloExperiencia()"
								[disabled]="loadingStates.workExperience">
								<i class="bi bi-check-lg me-1"></i>
								<span *ngIf="!loadingStates.workExperience">Guardar Módulo</span>
								<span *ngIf="loadingStates.workExperience">Guardando...</span>
							</button>
							<button class="btn btn-secondary" (click)="cancelarEdicionExperiencia()"
								[disabled]="loadingStates.workExperience">
								<i class="bi bi-x-lg me-1"></i>
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- PANEL DE DOS COLUMNAS: ESTUDIOS E IDIOMAS -->
			<div class="row g-4 mb-4">
				<!-- COLUMNA 1: ESTUDIOS ACADÉMICOS -->
				<div class="col-12 col-lg-6">
					<!-- 🎓 ESTUDIOS -->
					<div class="card shadow-lg border-0 h-100" style="border-radius: 15px; min-height: 500px;">
						<div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3"
							style="border-radius: 15px 15px 0 0;">
							<div class="d-flex align-items-center">
								<div class="bg-info bg-gradient rounded-circle p-3 me-3">
									<i class="bi bi-mortarboard-fill text-white fs-4"></i>
								</div>
								<div>
									<h5 class="mb-0 fw-bold text-dark">Estudios Académicos</h5>
									<small class="text-muted">Formación educativa y certificaciones</small>
								</div>
							</div>
							<button *ngIf="!editingModules.studies" class="btn btn-outline-success btn-sm rounded-pill px-2"
								(click)="editarEstudios()">
								<i class="bi bi-pencil me-1"></i>
								Editar
							</button>
						</div>
						<div class="card-body p-4" style="max-height: 400px; overflow-y: auto;">
							<!-- Modo vista -->
							<div *ngIf="!editingModules.studies">
								<div *ngIf="candidatoData.hasStudies?.length === 0" class="text-center py-5">
									<div class="bg-light rounded-circle p-4 mx-auto mb-3"
										style="width: 80px; height: 80px;">
										<i class="bi bi-mortarboard text-muted fs-2"></i>
									</div>
									<h6 class="text-muted">No hay estudios registrados</h6>
									<p class="text-muted small">Agrega tu formación académica</p>
								</div>
								<div class="row g-3" *ngIf="candidatoData.hasStudies?.length > 0">
									<div class="col-12" *ngFor="let study of candidatoData.hasStudies; let i = index">
										<div class="bg-light rounded-3 p-3 position-relative">
											<div class="position-absolute top-0 start-0 bg-success rounded-pill"
												style="width: 4px; height: 100%;"></div>
											<div class="ms-3">
												<div class="d-flex justify-content-between align-items-start mb-2">
													<div class="flex-grow-1">
														<h6 class="text-success fw-bold mb-1">{{ study.degree || 'Grado no
															especificado' }}</h6>
														<p class="text-dark fw-semibold mb-1">{{ study.institution ||
															'Institución no especificada' }}</p>
														<p class="text-muted small mb-0">
															<i class="bi bi-geo-alt me-1"></i>
															{{ study.state || 'Estado' }}, {{ study.municipality ||
															'Municipio' }}
														</p>
													</div>
													<span class="badge rounded-pill"
														[class.bg-success]="study.isGraduate"
														[class.bg-warning]="!study.isGraduate">
														<i class="bi" [class.bi-check-circle]="study.isGraduate"
															[class.bi-clock]="!study.isGraduate" class="me-1"></i>
														{{ study.isGraduate ? 'Graduado' : 'En curso' }}
													</span>
												</div>
												<div class="mt-2">
													<p class="text-muted small mb-0">
														<i class="bi bi-calendar3 me-1"></i>
														<strong>Fecha:</strong> {{ study.issueDate || 'No especificada'
														}}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Modo edición -->
							<div *ngIf="editingModules.studies">
								<!-- Lista de estudios existentes -->
								<div *ngFor="let study of candidatoData.hasStudies; let i = index" class="border p-3 mb-3 rounded">
									<div class="d-flex justify-content-between align-items-start">
										<div>
											<h6>{{ study.degree || 'Grado no especificado' }}</h6>
											<p class="text-muted mb-1">{{ study.institution || 'Institución no especificada' }}</p>
											<p class="text-muted mb-0">
												<small>{{ study.state || 'Estado' }}, {{ study.municipality || 'Municipio' }}</small>
											</p>
										</div>
										<div class="btn-group">
											<button class="btn btn-outline-primary btn-sm" (click)="editarEstudio(i)">
												<i class="bi bi-pencil"></i>
											</button>
											<button class="btn btn-outline-danger btn-sm" (click)="eliminarEstudio(i)">
												<i class="bi bi-trash"></i>
											</button>
										</div>
									</div>
								</div>

								<!-- Formulario para agregar/editar estudio -->
								<div class="border p-3 mb-3 rounded bg-light" *ngIf="editIndexes.study !== null">
									<h6>{{ editIndexes.study >= 0 ? 'Editar' : 'Agregar' }} Estudio</h6>
									<div class="row">
										<div class="col-md-6">
											<div class="mb-3">
												<label class="form-label">Grado/Carrera</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.study.degree">
											</div>
											<div class="mb-3">
												<label class="form-label">Institución</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.study.institution">
											</div>
											<div class="mb-3">
												<label class="form-label">Estado</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.study.state">
											</div>
										</div>
										<div class="col-md-6">
											<div class="mb-3">
												<label class="form-label">Municipio</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.study.municipality">
											</div>
											<div class="mb-3">
												<label class="form-label">Fecha de emisión</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.study.issueDate"
													placeholder="Ej: Diciembre 2022">
											</div>
											<div class="mb-3">
												<div class="form-check">
													<input class="form-check-input" type="checkbox"
														[(ngModel)]="editingData.study.isGraduate">
													<label class="form-check-label">
														¿Ya se graduó?
													</label>
												</div>
											</div>
										</div>
									</div>
									<div class="d-flex gap-2">
										<button class="btn btn-success btn-sm" (click)="guardarEstudio()">
											<i class="bi bi-check-lg me-1"></i>
											Guardar
										</button>
										<button class="btn btn-secondary btn-sm" (click)="cancelarEdicionItem()">
											<i class="bi bi-x-lg me-1"></i>
											Cancelar
										</button>
									</div>
								</div>

								<!-- Botón para agregar nuevo estudio -->
								<button class="btn btn-outline-primary mb-3" (click)="agregarEstudio()">
									<i class="bi bi-plus-lg me-1"></i>
									Agregar Estudio
								</button>

								<!-- Botones de acción del módulo -->
								<div class="d-flex gap-2">
									<button class="btn btn-success" (click)="guardarModuloEstudios()"
										[disabled]="loadingStates.studies">
										<i class="bi bi-check-lg me-1"></i>
										<span *ngIf="!loadingStates.studies">Guardar Módulo</span>
										<span *ngIf="loadingStates.studies">Guardando...</span>
									</button>
									<button class="btn btn-secondary" (click)="cancelarEdicionEstudios()"
										[disabled]="loadingStates.studies">
										<i class="bi bi-x-lg me-1"></i>
										Cancelar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- COLUMNA 2: IDIOMAS -->
				<div class="col-12 col-lg-6">
					<!-- 🌐 IDIOMAS -->
					<div class="card shadow-lg border-0 h-100" style="border-radius: 15px; min-height: 500px;">
						<div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3"
							style="border-radius: 15px 15px 0 0;">
							<div class="d-flex align-items-center">
								<div class="bg-info bg-gradient rounded-circle p-3 me-3">
									<i class="bi bi-translate text-white fs-4"></i>
								</div>
								<div>
									<h5 class="mb-0 fw-bold text-dark">Idiomas</h5>
									<small class="text-muted">Competencias lingüísticas</small>
								</div>
							</div>
							<button *ngIf="!editingModules.languages" class="btn btn-outline-success btn-sm rounded-pill px-2"
								(click)="editarIdiomas()">
								<i class="bi bi-pencil me-1"></i>
								Editar
							</button>
						</div>
						<div class="card-body p-4" style="max-height: 400px; overflow-y: auto;">
							<!-- Modo vista -->
							<div *ngIf="!editingModules.languages">
								<div *ngIf="candidatoData.hasLanguages?.length === 0" class="text-center py-5">
									<div class="bg-light rounded-circle p-4 mx-auto mb-3" style="width: 80px; height: 80px;">
										<i class="bi bi-translate text-muted fs-2"></i>
									</div>
									<h6 class="text-muted">No hay idiomas registrados</h6>
									<p class="text-muted small">Agrega tus competencias lingüísticas</p>
								</div>
								<div class="row g-3" *ngIf="candidatoData.hasLanguages?.length > 0">
									<div class="col-12" *ngFor="let lang of candidatoData.hasLanguages; let i = index">
										<div class="bg-light rounded-3 p-3 position-relative">
											<div class="position-absolute top-0 start-0 bg-success rounded-pill"
												style="width: 4px; height: 100%;"></div>
											<div class="ms-3">
												<div class="d-flex justify-content-between align-items-center">
													<div>
														<h6 class="text-success fw-bold mb-1">{{ lang.name || 'Idioma no
															especificado' }}</h6>
														<div class="d-flex align-items-center">
															<span class="badge bg-success bg-gradient me-2">
																{{ lang.level || 'Nivel no especificado' }}
															</span>
															<small class="text-muted">
																<i class="bi bi-star-fill me-1"></i>
																Nivel de dominio
															</small>
														</div>
													</div>
													<div class="text-center">
														<div class="progress mb-1" style="width: 80px; height: 8px;">
															<div class="progress-bar bg-success"
																[style.width]="getLanguageProgress(lang.level) + '%'">
															</div>
														</div>
														<small class="text-muted">{{ getLanguageProgress(lang.level) }}%</small>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Modo edición -->
							<div *ngIf="editingModules.languages">
								<!-- Lista de idiomas existentes -->
								<div *ngFor="let lang of candidatoData.hasLanguages; let i = index" class="border p-3 mb-3 rounded">
									<div class="d-flex justify-content-between align-items-start">
										<div>
											<h6>{{ lang.name || 'Idioma no especificado' }}</h6>
											<p class="text-muted mb-1">Nivel: {{ lang.level || 'No especificado' }}</p>
											<p class="text-muted mb-0">Institución: {{ lang.institution || 'No especificada' }}</p>
										</div>
										<div class="btn-group">
											<button class="btn btn-outline-primary btn-sm" (click)="editarIdioma(i)">
												<i class="bi bi-pencil"></i>
											</button>
											<button class="btn btn-outline-danger btn-sm" (click)="eliminarIdioma(i)">
												<i class="bi bi-trash"></i>
											</button>
										</div>
									</div>
								</div>

								<!-- Formulario para agregar/editar idioma -->
								<div class="border p-3 mb-3 rounded bg-light" *ngIf="editIndexes.language !== null">
									<h6>{{ editIndexes.language >= 0 ? 'Editar' : 'Agregar' }} Idioma</h6>
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="form-label">Idioma</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.language.name">
											</div>
										</div>
										<div class="col-md-4">
											<div class="mb-3">
												<label class="form-label">Nivel</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.language.level"
													placeholder="Ej: Básico, Intermedio, Avanzado">
											</div>
										</div>
										<div class="col-md-4">
											<div class="mb-3">
												<label class="form-label">Institución</label>
												<input type="text" class="form-control" [(ngModel)]="editingData.language.institution">
											</div>
										</div>
									</div>
									<div class="d-flex gap-2">
										<button class="btn btn-success btn-sm" (click)="guardarIdioma()">
											<i class="bi bi-check-lg me-1"></i>
											Guardar
										</button>
										<button class="btn btn-secondary btn-sm" (click)="cancelarEdicionItem()">
											<i class="bi bi-x-lg me-1"></i>
											Cancelar
										</button>
									</div>
								</div>

								<!-- Botón para agregar nuevo idioma -->
								<button class="btn btn-outline-primary mb-3" (click)="agregarIdioma()">
									<i class="bi bi-plus-lg me-1"></i>
									Agregar Idioma
								</button>

								<!-- Botones de acción del módulo -->
								<div class="d-flex gap-2">
									<button class="btn btn-success" (click)="guardarModuloIdiomas()"
										[disabled]="loadingStates.languages">
										<i class="bi bi-check-lg me-1"></i>
										<span *ngIf="!loadingStates.languages">Guardar Módulo</span>
										<span *ngIf="loadingStates.languages">Guardando...</span>
									</button>
									<button class="btn btn-secondary" (click)="cancelarEdicionIdiomas()"
										[disabled]="loadingStates.languages">
										<i class="bi bi-x-lg me-1"></i>
										Cancelar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 🏆 CERTIFICACIONES -->
			<div class="card shadow-lg border-0 mb-4" style="border-radius: 15px;">
				<div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3"
					style="border-radius: 15px 15px 0 0;">
					<div class="d-flex align-items-center">
						<div class="bg-info bg-gradient rounded-circle p-3 me-3">
							<i class="bi bi-award-fill text-white fs-4"></i>
						</div>
						<div>
							<h5 class="mb-0 fw-bold text-dark">Certificaciones</h5>
							<small class="text-muted">Certificados y acreditaciones</small>
						</div>
					</div>
					<button *ngIf="!editingModules.certifications" class="btn btn-outline-success btn-lg rounded-pill px-4"
						(click)="editarCertificaciones()">
						<i class="bi bi-pencil me-1"></i>
						Editar
					</button>
				</div>
				<div class="card-body">
					<!-- Modo vista -->
					<div *ngIf="!editingModules.certifications">
						<div *ngIf="candidatoData.hvpocCertificacion?.length === 0" class="text-muted">
							No hay certificaciones registradas
						</div>
						<div *ngFor="let cert of candidatoData.hvpocCertificacion; let i = index"
							class="border-bottom pb-3 mb-3">
							<h6>{{ cert.nombre || 'Certificación no especificada' }}</h6>
							<p class="text-muted mb-1">Institución: {{ cert.institucion || 'No especificada' }}</p>
							<p class="text-muted mb-0">
								<small>Número: {{ cert.numero || 'No especificado' }}</small>
								<span *ngIf="cert.fache_exp" class="ms-3">
									<small>Vencimiento: {{ cert.fache_exp }}</small>
								</span>
							</p>
						</div>
					</div>
					<!-- Modo edición -->
					<div *ngIf="editingModules.certifications">
						<!-- Lista de certificaciones existentes -->
						<div *ngFor="let cert of candidatoData.hvpocCertificacion; let i = index"
							class="border p-3 mb-3 rounded">
							<div class="d-flex justify-content-between align-items-start">
								<div>
									<h6>{{ cert.nombre || 'Certificación no especificada' }}</h6>
									<p class="text-muted mb-1">Institución: {{ cert.institucion || 'No especificada' }}
									</p>
									<p class="text-muted mb-0">Número: {{ cert.numero || 'No especificado' }}</p>
								</div>
								<div class="btn-group">
									<button class="btn btn-outline-primary btn-sm" (click)="editarCertificacion(i)">
										<i class="bi bi-pencil"></i>
									</button>
									<button class="btn btn-outline-danger btn-sm" (click)="eliminarCertificacion(i)">
										<i class="bi bi-trash"></i>
									</button>
								</div>
							</div>
						</div>

						<!-- Formulario para agregar/editar certificación -->
						<div class="border p-3 mb-3 rounded bg-light" *ngIf="editIndexes.certification !== null">
							<h6>{{ editIndexes.certification >= 0 ? 'Editar' : 'Agregar' }} Certificación</h6>
							<div class="row">
								<div class="col-md-6">
									<div class="mb-3">
										<label class="form-label">Nombre de la Certificación</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.certification.nombre">
									</div>
									<div class="mb-3">
										<label class="form-label">Institución</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.certification.institucion">
									</div>
								</div>
								<div class="col-md-6">
									<div class="mb-3">
										<label class="form-label">Número de Certificación</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.certification.numero">
									</div>
									<div class="mb-3">
										<label class="form-label">Fecha de Expiración</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.certification.fache_exp"
											placeholder="Ej: Diciembre 2025">
									</div>
								</div>
							</div>
							<div class="d-flex gap-2">
								<button class="btn btn-success btn-sm" (click)="guardarCertificacion()">
									<i class="bi bi-check-lg me-1"></i>
									Guardar
								</button>
								<button class="btn btn-secondary btn-sm" (click)="cancelarEdicionItem()">
									<i class="bi bi-x-lg me-1"></i>
									Cancelar
								</button>
							</div>
						</div>

						<!-- Botón para agregar nueva certificación -->
						<button class="btn btn-outline-primary mb-3" (click)="agregarCertificacion()">
							<i class="bi bi-plus-lg me-1"></i>
							Agregar Certificación
						</button>

						<!-- Botones de acción del módulo -->
						<div class="d-flex gap-2">
							<button class="btn btn-success" (click)="guardarModuloCertificaciones()"
								[disabled]="loadingStates.certifications">
								<i class="bi bi-check-lg me-1"></i>
								<span *ngIf="!loadingStates.certifications">Guardar Módulo</span>
								<span *ngIf="loadingStates.certifications">Guardando...</span>
							</button>
							<button class="btn btn-secondary" (click)="cancelarEdicionCertificaciones()"
								[disabled]="loadingStates.certifications">
								<i class="bi bi-x-lg me-1"></i>
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- ⚡ ESPECIALIDADES -->
			<div class="card shadow-lg border-0 mb-4" style="border-radius: 15px;">
				<div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3"
					style="border-radius: 15px 15px 0 0;">
					<div class="d-flex align-items-center">
						<div class="bg-info bg-gradient rounded-circle p-3 me-3">
							<i class="bi bi-lightning-fill text-white fs-4"></i>
						</div>
						<div>
							<h5 class="mb-0 fw-bold text-dark">Especialidades</h5>
							<small class="text-muted">Áreas de especialización</small>
						</div>
					</div>
					<button *ngIf="!editingModules.specialties" class="btn btn-outline-success btn-lg rounded-pill px-4"
						(click)="editarEspecialidades()">
						<i class="bi bi-pencil me-1"></i>
						Editar
					</button>
				</div>
				<div class="card-body">

					<!-- Modo vista -->
					<div *ngIf="!editingModules.specialties">
						<div *ngIf="candidatoData.hvpocEspecialidad?.length === 0" class="text-muted">
							No hay especialidades registradas
						</div>
						<div *ngFor="let spec of candidatoData.hvpocEspecialidad; let i = index"
							class="border-bottom pb-3 mb-3">
							<h6>{{ spec.area || 'Área no especificada' }}</h6>
							<p class="text-muted mb-0">
								Años de experiencia: {{ spec.annos_experiencia || 'No especificado' }}
							</p>
						</div>
					</div>

					<!-- Modo edición -->
					<div *ngIf="editingModules.specialties">
						<!-- Lista de especialidades existentes -->
						<div *ngFor="let spec of candidatoData.hvpocEspecialidad; let i = index"
							class="border p-3 mb-3 rounded">
							<div class="d-flex justify-content-between align-items-start">
								<div>
									<h6>{{ spec.area || 'Área no especificada' }}</h6>
									<p class="text-muted mb-0">Años de experiencia: {{ spec.annos_experiencia || 'No
										especificado' }}</p>
								</div>
								<div class="btn-group">
									<button class="btn btn-outline-primary btn-sm" (click)="editarEspecialidad(i)">
										<i class="bi bi-pencil"></i>
									</button>
									<button class="btn btn-outline-danger btn-sm" (click)="eliminarEspecialidad(i)">
										<i class="bi bi-trash"></i>
									</button>
								</div>
							</div>
						</div>

						<!-- Formulario para agregar/editar especialidad -->
						<div class="border p-3 mb-3 rounded bg-light" *ngIf="editIndexes.specialty !== null">
							<h6>{{ editIndexes.specialty >= 0 ? 'Editar' : 'Agregar' }} Especialidad</h6>
							<div class="row">
								<div class="col-md-8">
									<div class="mb-3">
										<label class="form-label">Área de Especialidad</label>
										<input type="text" class="form-control"
											[(ngModel)]="editingData.specialty.area">
									</div>
								</div>
								<div class="col-md-4">
									<div class="mb-3">
										<label class="form-label">Años de Experiencia</label>
										<input type="number" class="form-control"
											[(ngModel)]="editingData.specialty.annos_experiencia">
									</div>
								</div>
							</div>
							<div class="d-flex gap-2">
								<button class="btn btn-success btn-sm" (click)="guardarEspecialidad()">
									<i class="bi bi-check-lg me-1"></i>
									Guardar
								</button>
								<button class="btn btn-secondary btn-sm" (click)="cancelarEdicionItem()">
									<i class="bi bi-x-lg me-1"></i>
									Cancelar
								</button>
							</div>
						</div>

						<!-- Botón para agregar nueva especialidad -->
						<button class="btn btn-outline-primary mb-3" (click)="agregarEspecialidad()">
							<i class="bi bi-plus-lg me-1"></i>
							Agregar Especialidad
						</button>

						<!-- Botones de acción del módulo -->
						<div class="d-flex gap-2">
							<button class="btn btn-success" (click)="guardarModuloEspecialidades()"
								[disabled]="loadingStates.specialties">
								<i class="bi bi-check-lg me-1"></i>
								<span *ngIf="!loadingStates.specialties">Guardar Módulo</span>
								<span *ngIf="loadingStates.specialties">Guardando...</span>
							</button>
							<button class="btn btn-secondary" (click)="cancelarEdicionEspecialidades()"
								[disabled]="loadingStates.specialties">
								<i class="bi bi-x-lg me-1"></i>
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- 🎯 HABILIDADES Y LOGROS -->
			<div class="card shadow-lg border-0 mb-4" style="border-radius: 15px;">
				<div class="card-header bg-white border-0 d-flex justify-content-between align-items-center py-3"
					style="border-radius: 15px 15px 0 0;">
					<div class="d-flex align-items-center">
						<div class="bg-info bg-gradient rounded-circle p-3 me-3">
							<i class="bi bi-trophy-fill text-white fs-4"></i>
						</div>
						<div>
							<h5 class="mb-0 fw-bold text-dark">Habilidades y Logros</h5>
							<small class="text-muted">Competencias y logros destacados</small>
						</div>
					</div>
					<button *ngIf="!editingModules.skillsAchievements" class="btn btn-outline-success btn-lg rounded-pill px-4"
						(click)="editarHabilidadesLogros()">
						<i class="bi bi-pencil me-1"></i>
						Editar
					</button>
				</div>
				<div class="card-body">
					<!-- Modo vista -->
					<div *ngIf="!editingModules.skillsAchievements">
						<div class="row g-4">
							<div class="col-12 col-md-6">
								<div
									class="p-4 rounded-4 bg-light border border-2 border-success border-opacity-25 h-100">
									<div class="d-flex align-items-center mb-3">
										<div class="bg-info bg-gradient rounded-circle p-2 me-3">
											<i class="bi bi-gear-fill text-white"></i>
										</div>
										<h6 class="mb-0 fw-bold text-success">Habilidades</h6>
									</div>
									<div style="max-height: 600px; overflow-y: auto;">
										<div *ngIf="!candidatoData?.skills || candidatoData.skills.trim().length === 0"
											class="text-muted text-center py-3">
											<i class="bi bi-info-circle me-2"></i>
											No hay habilidades registradas
										</div>
										<div *ngIf="candidatoData?.skills && candidatoData.skills.trim().length > 0"
											class="d-flex flex-wrap gap-2">
											<span *ngFor="let skill of getSkillsArray()"
												class="badge bg-info bg-gradient px-3 py-2 rounded-pill">
												<i class="bi bi-tools me-1"></i>{{ skill }}
											</span>
										</div>
									</div>
								</div>
							</div>

							<div class="col-12 col-md-6">
								<div
									class="p-4 rounded-4 bg-light border border-2 border-success border-opacity-25 h-100">
									<div class="d-flex align-items-center mb-3">
										<div class="bg-info bg-gradient rounded-circle p-2 me-3">
											<i class="bi bi-trophy-fill text-white"></i>
										</div>
										<h6 class="mb-0 fw-bold text-success">Logros</h6>
									</div>
									<div style="max-height: 600px; overflow-y: auto;">
										<div *ngIf="!candidatoData?.achievments || candidatoData.achievments.trim().length === 0"
											class="text-muted text-center py-3">
											<i class="bi bi-info-circle me-2"></i>
											No hay logros registrados
										</div>
										<ul class="list-unstyled"
											*ngIf="candidatoData?.achievments && candidatoData.achievments.trim().length > 0">
											<li *ngFor="let achievement of getAchievementsArray()"
												class="mb-3 p-2 rounded-3 bg-white border border-success border-opacity-25">
												<i class="bi bi-star-fill text-warning me-2"></i>
												{{ achievement }}
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Modo edición -->
					<div *ngIf="editingModules.skillsAchievements">
						<div class="row g-4">
							<div class="col-12 col-md-6">
								<div
									class="p-4 rounded-4 bg-light border border-2 border-success border-opacity-25 h-100">
									<div class="d-flex align-items-center mb-3">
										<div class="bg-success bg-gradient rounded-circle p-2 me-3">
											<i class="bi bi-gear-fill text-white"></i>
										</div>
										<h6 class="mb-0 fw-bold text-success">Habilidades Técnicas</h6>
									</div>
									<div class="form-floating">
										<textarea class="form-control border-0 bg-transparent" id="skills"
											[(ngModel)]="candidatoData.skills"
											placeholder="Describe tus habilidades técnicas separadas por punto y coma..."
											style="min-height: 400px; resize: none;"></textarea>
										<label for="skills" class="text-muted">
											<i class="bi bi-tools me-2"></i>Habilidades técnicas (separadas por punto y coma)
										</label>
									</div>
								</div>
							</div>

							<div class="col-12 col-md-6">
								<div
									class="p-4 rounded-4 bg-light border border-2 border-success border-opacity-25 h-100">
									<div class="d-flex align-items-center mb-3">
										<div class="bg-success bg-gradient rounded-circle p-2 me-3">
											<i class="bi bi-trophy-fill text-white"></i>
										</div>
										<h6 class="mb-0 fw-bold text-success">Logros Destacados</h6>
									</div>
									<div class="form-floating">
										<textarea class="form-control border-0 bg-transparent" id="achievments"
											[(ngModel)]="candidatoData.achievments"
											placeholder="Comparte tus logros más importantes, separadas por punto y coma..."
											style="min-height: 400px; resize: none;"></textarea>
										<label for="achievments" class="text-muted">
											<i class="bi bi-star me-2"></i>Logros principales (separadas por punto y coma)
										</label>
									</div>
								</div>
							</div>
						</div>

						<div class="d-flex gap-2">
							<button type="button" class="btn btn-success"
								(click)="guardarHabilidadesLogros()" [disabled]="loadingStates.skillsAchievements">
								<span *ngIf="loadingStates.skillsAchievements"
									class="spinner-border spinner-border-sm me-2"></span>
								<i *ngIf="!loadingStates.skillsAchievements" class="bi bi-check-circle me-2"></i>
								Guardar Habilidades y Logros
							</button> 
							<button type="button" class="btn btn-secondary" style="margin-left:15px"
								(click)="cancelarEdicionHabilidadesLogros()"
								[disabled]="loadingStates.skillsAchievements">
								<i class="bi bi-x-lg me-2"></i>
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>